import React from 'react';
import { Card } from './Card';
import { InteractionsIcon } from '../icons/InteractionsIcon';
import { Diff } from '../Diff';
import { AttentionIcon } from '../icons/AttentionIcon';
import { getDiff } from '../../model/Diff';
import { Information } from '../Information';
import { t } from '../../i18n';

const InteractionsMetricsCard = ({ count, previousCount, time, previousTime }: Props) => {
  return (
    <Card>
      <div className="card-body">
        <div className="d-flex align-items-center mb-4">
          <Information id="interactionCoreMetrics" content={<h5 className="card-title m-0 me-2">{t('cards.interactionCoreMetrics')}</h5>} />
          <Information id="interactionCoreMetrics" showMore={true} />
        </div>
        <div className="row align-items-center text-dark mb-4">
          <div className="col-6 d-flex align-items-center">
            <InteractionsIcon />
            <Information id="interactions" content= {<span className="ms-3 me-2 text-black">{t('cards.interactions')}</span>} />
            <Information id="interactions" showMore={true} />
          </div>
          <div className="col-6 d-flex align-items-center justify-content-end">
            <span className="me-2 fs-5">{count}</span>
            <Diff value={getDiff(count, previousCount)} />
          </div>
        </div>
        <div className="row align-items-center text-dark">
          <div className="col-6 d-flex align-items-center">
            <AttentionIcon />
            <Information id="avgTime" content={<span className="ms-3 me-2 text-black">{t('cards.avgTime')}</span>} />
            <Information id="avgTime" showMore={true} />
          </div>
          <div className="col-6 d-flex align-items-center justify-content-end">
            <span className="me-2 fs-5">{time.toFixed(1) + 's'}</span>
            <Diff value={getDiff(time, previousTime)} />
          </div>
        </div>
      </div>
    </Card>);
}

interface Props {
  count: number,
  time: number,
  previousCount: number,
  previousTime: number
}

export { InteractionsMetricsCard };